import {MI} from "../init.js";
import {he, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {getArrayRandValue, getRandomBoolean, getRandomInt} from "../../framework/src/helpers";

/**
 * @abstract
 * @constructor
 * @param {MadnesGroup} group
 * @returns {undefined}
 */
export function Storm(group) {

    /** @type {MadnesGroup} */
    this._group = group;

    /** @type {Array<MadnesObject>} */
    this._flashes = [];

    /** @type {Array<MadnesTimer>} */
    this._flashesTimers = [];

    this._flashesPromises = [];

    this._isRunning = false;
};

Storm.flashNumbers = [1, 2, 3, 6];

/**
 * @returns {MadnesGraphics}
 */
Storm.prototype._crateShine = function() {

    var g = MI.addGraphics(0, 0);
    g.beginFill(0xFFC900);
    g.drawRectangle(0, 0, wi, he);
    g.setBlend("ADD");
    g.setAlpha(0);

    return g;
};

/**
 * @param {MadnesObject} flash
 */
Storm.prototype._setRandTexture = function(flash) {

    var num = getArrayRandValue(Storm.flashNumbers);
    flash.setTexture("storm_0" + num);
};

/**
 * @param {MadnesObject} flash
 * @returns {Object}
 */
Storm.prototype._getFlashPos = function(flash) {

    var x = getRandomInt(280, 1000);
    var y = getRandomInt(50, 400);

    var yTo = getRandomInt(520, 600);
    var sc = ((yTo - y) / flash.getTextureHeight());
    var d = Math.random() >= 0.5 ? -1 : 1;

    return {
        'posX': x,
        'posY': y,
        'scaleX': sc * d,
        'scaleY': sc
    }
};

/**
 * @param {MadnesObject} flash
 * @returns {undefined}
 */
Storm.prototype._setFlashPos = function(flash) {
    var dim = this._getFlashPos(flash);
    flash.setPos(dim['posX'], dim['posY']);
    flash.setScale(dim['scaleX'], dim['scaleY']);
};

Storm.prototype._playFlashAnim = function(flash) {
    var _self = this;

    flash.setAlpha(0);
    flash.setVisible(true);

    //var r = getRandomInt(100, 150);

    return new Promise(function(res) {

//			if(shine && getRandomBoolean()) {
//				var sh = _self._crateShine();
//				MI.addTween().to(sh, { 'alpha': 0.3 }, {
//					'duration': 100,
//					'yoyo': true,
//					'callback': function() {
//						sh.destroy();
//					}
//				});
//
//				_self._group.add(sh);
//				//_self._shines.push(shine);
//			}

        if(getRandomBoolean()) {
            _self._playFlashAnimBlinkIn(flash, function() {

//				    if(getRandomBoolean() && false) {
//						_self._playFlashAnimBlinkOut(flash, callback);
//				    } else {
                MI.addTween().to(flash, { 'alpha': 0 }, {
                    'duration': 300,
                    'callback': function() {
                        res();
                    }
                });
//					}
            });
        } else {
            MI.addTween().to(flash, { 'alpha': 1 }, {
                'duration': 100,
                //'delay': getRandomInt(60, 120),
                'callback': function() {

//						if(getRandomBoolean() && false) {
//							_self._playFlashAnimBlinkOut(flash, callback);
//				        } else {
                    MI.addTween().to(flash, { 'alpha': 0 }, {
                        'duration': 440,
                        'callback': function() {
                            res();
                        }
                    });
//				        }
                }
            });
        }
    });
};

Storm.prototype._playFlashAnimBlinkIn = function(flash, callback) {
    MI.addTween().to(flash, { 'alpha': 0.6 }, {
        'duration': 80,
        //'delay': getRandomInt(60, 120),
        'callback': function() {
            MI.addTween().to(flash, { 'alpha': 0.2 }, {
                'duration': 80,
                'callback': function() {
                    MI.addTween().to(flash, { 'alpha': 1 }, {
                        'duration': 80,
                        'callback': callback
                    });
                }
            });
        }
    });
};

Storm.prototype._playFlashAnimBlinkOut = function(flash, callback) {
    MI.addTween().to(flash, { 'alpha': 0.3 }, {
        'duration': 80,
        'callback': function() {
            MI.addTween().to(flash, { 'alpha': 0.7 }, {
                'duration': 80,
                'callback': function() {
                    MI.addTween().to(flash, { 'alpha': 0 }, {
                        'duration': 80,
                        'callback': callback
                    });
                }
            });
        }
    });
};

/**
 * @returns {Promise}
 */
Storm.prototype.stop = function() {

    var _self = this;

    this._isRunning = false;

    for(var i = 0; i < this._flashesTimers.length; i++) {
        this._flashesTimers[i].stop();
    }

    this._flashesTimers.length = 0;

    return Promise.all(this._flashesPromises).then(function() {
        _self.destroy();
    });
};

Storm.prototype.destroy = function() {

//	if(this._isRunning) {
//		throw new Error('cannot destroy - storm is still running, call `stop` method');
//	}

    for(var i = 0; i < this._flashes.length; i++) {
        this._flashes[i] && this._flashes[i].destroy();
    }
    this._flashes.length = 0;

    this._flashesPromises.length = 0;
};